module.exports = {
          srcSet: __webpack_public_path__ + "efc937815e459521d3505431c7bbed59-120.png"+" 120w",
          images:[ {path: __webpack_public_path__ + "efc937815e459521d3505431c7bbed59-120.png",width: 120,height: 120}],
          src: __webpack_public_path__ + "efc937815e459521d3505431c7bbed59-120.png",
          toString:function(){return __webpack_public_path__ + "efc937815e459521d3505431c7bbed59-120.png"},
          
          width: 120,
          height: 120
        }